// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3330": "1852a85d","3573": "ffd50735","3969": "920ac668","4619": "4b303110","4841": "2a4bd4fa","5128": "29d4dba2","8389": "4218de61",}[chunkId] + ".css"
}